/* eslint-disable*/
import { useEffect, useRef, useState } from 'react';
// import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { connect, useDispatch } from 'react-redux';

import IconButton from '@mui/material/IconButton';
import {
	InputAdornment,
	OutlinedInput,
	FormControl,
	InputLabel,
	Skeleton,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Redirect } from 'react-router-dom';
import { get } from 'lodash';
import {
	setCookie,
	getCookie,
	deleteCookie,
} from '../../../Services/Storage Services';
import { useAuth } from './auth';
import { notificationServices, authServices } from '../../../Services';
import {
	formatMetricValue,
	getRandomNeonDarkColor, history, inputHelper,
	maskEmail,
	useProductData
} from '../../../Helpers';
import { analyticsAction, modalActions, navigationActions } from '../../../Actions';
import styles from './Login.module.scss';
// import uyNoBg from '../../../Images/uyLogo.png';
import userRolesAndPermissions from '../../../Services/userRolesAndPermissions.services';
import modulesConfiguration from '../../../Services/modulesConfiguration.services';
import { urls } from '@/Constants';
import { resetLogoutFlag } from '@/Services/helpers';
import { TrendingUp, Users, Package, Activity, Phone, Mail, Award, ArrowRight, Eye, EyeOff, ChevronLeft, ChevronRight, User, Lock, Shield, FileText, Star, Globe, Factory, GraduationCap, ExternalLink, ArrowLeft, Calculator } from 'lucide-react';
import { Button } from '@/Components/ui/button';
import { Input } from '@/Components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/Components/ui/card';
import { ImageWithFallback } from './ImageWithFallback';
import udyogYantraLogo from '../../../Images/uyLogo.png';
import map from '../../../Images/map.png';
import etDistributor from '../../../Images/etDistributor.png';
import achive from '../../../Images/Achievements.png';
import group from '../../../Images/Group 1410264477 (1).png';
import resoee from '../../../Images/resoee.png';
import { Badge } from '@/Components/ui/badge';
import { Tabs, TabsList, TabsTrigger } from '@/Components/ui/tabs';
import useAuthInit from '@/Helpers/useAuthInit';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles(() => {
	return {
		paper: {
			marginTop: '5rem',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
		},
		form: {
			width: '100%',
			marginTop: '1rem',
		},
		submit: {
			margin: '1rem 0px 2rem 0px',
		},
		version: {
			marginTop: 'auto',
			textAlign: 'center',
			color: 'rgba(0,0,0,0.5)',
		},
	};
});

const initialState = {
	username: '',
	nextStep: 0,
	password: '',
	otp: ['', '', '', ''],
	timeLeft: 60,
	userEmail: '',
	userId: null,
};

const tabList = [
	{
		label: 'OTP',
		value: 'otp',
		icon: <Calculator size={16} />
	},
	{
		label: 'Password',
		value: 'password',
		icon: <Lock size={16} />
	}
];

const Login = ({ navState, fetchedConfig }) => {
	const [isforced, setIsForced] = useState(false);
	const classes = useStyles();
	const {
		isLoggedIn,
		signIn,
		setAppConfig,
		appConfig,
		setUserConfig,
		signout,
		setUserStores,
	} = useAuth();

	const [state, setState] = useState({
		...initialState,
	});
	const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
	const { username, nextStep, otp, timeLeft, userEmail, userId, password } = state;
	const [loading, setLoading] = useState(false);
	const [otpError, setOtpError] = useState(false);
	const [toggleMode, setToggleMode] = useState('otp');
	const [showPassword, setShowPassword] = useState(false);
	const [lastEmailModify, setLastEmailModify] = useState(false);
	const usernameRef = useRef(null);
	const dispatch = useDispatch();
	// const [fetchedConfig, setFetchedConfig] = useState(false);
	const [currentSlide, setCurrentSlide] = useState(0);
	const [misSummary, setMisSummary] = useState(null);
	const isA2bCustomer = appConfig?.customerId === 68 || appConfig?.customerId === 5;
	const isBakingoCustomer = appConfig?.customerId === 52;
	const isMonginisCustomer = appConfig?.customerId === 63;

	const slides = [
		{
			type: 'company',
			title: 'UdyogYantra Details'
		},
		{
			type: 'impact',
			title: 'Our Impact & Key Metrics'
		},
		{
			type: 'credentials',
			title: 'Credentials & Certifications'
		},
		{
			type: 'achievement',
			title: 'Our Achievements & Awards',
			image: etDistributor, // Using identifier for problematic image
			fallbackContent: 'ET NOW AI Disruptor 2024 Award'
		},
		{
			type: 'achievement',
			title: 'Our Achievements & Awards',
			image: map,
			fallbackContent: 'StartUp Insights Recognition'
		},
		{
			type: 'group',
			title: 'Your Total Kitchen Control',
			image: group,
			fallbackContent: 'Your Total Kitchen Control'
		},
		{
			type: 'global-recognition',
			title: 'FAO 80th Anniversary Recognition ',
			image: achive,
			fallback: 'FAO 80th Anniversary Recognition '
		}
	];

	const fetchMisSummary = async () => {
		const MIS_SUMMARY_CACHE_KEY = 'misSummaryCache';
		const MIS_SUMMARY_DATE_KEY = 'misSummaryDate';

		const today = new Date().toISOString().split('T')[0];

		const cachedDate = localStorage.getItem(MIS_SUMMARY_DATE_KEY);
		const cachedData = localStorage.getItem(MIS_SUMMARY_CACHE_KEY);

		if (cachedDate === today && cachedData) {
			try {
				const parsedData = JSON.parse(cachedData);
				setMisSummary(parsedData);
				return;
			} catch (error) {
				console.log('Error parsing cached misSummary:', error);
			}
		}

		try {
			const res = await authServices.fetchMisSummary()?.then((res) => res.text()).then((res) => JSON.parse(res));
			if (res?.statusCode === 200) {
				setMisSummary(res?.data);
				// Cache the data with today's date
				localStorage.setItem(MIS_SUMMARY_CACHE_KEY, JSON.stringify(res?.data));
				localStorage.setItem(MIS_SUMMARY_DATE_KEY, today);
			}
		} catch (error) {
			console.log(error);
			if (cachedData) {
				try {
					const parsedData = JSON.parse(cachedData);
					setMisSummary(parsedData);
				} catch (parseError) {
					console.log('Error parsing fallback cached data:', parseError);
				}
			}
		}
	}

	useEffect(() => {
		fetchMisSummary();
	}, []);

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentSlide((prev) => (prev + 1) % slides.length);
		}, 4000);
		return () => clearInterval(interval);
	}, [slides.length]);

	useEffect(() => {
		if (!loading && nextStep === 0) {
			usernameRef.current?.focus();
		}
	}, [loading, nextStep, toggleMode]);

	useEffect(() => {
		if (timeLeft > 0) {
			const timer = setInterval(() => {
				setState((prev) => ({
					...prev,
					timeLeft: prev.timeLeft - 1,
				}));
			}, 1000);
			return () => clearInterval(timer);
		}
	}, [timeLeft])

	const sendOtp = async (resend = false) => {
		if (!fetchedConfig) {
			notificationServices.generateNotification({
				type: 'error',
				message: ' Config not fetched, Refreshing Page...',
			});
			setTimeout(() => {
				window.location.reload();
			}, 200);
			return;
		}
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'Loading...',
		});
		setLoading(true);
		resetLogoutFlag();
		try {
			const payload = {
				UserName: username,
			}
			if (resend === true) {
				payload.resendOtp = true;
				payload.userId = userId;
			}
			const res = await authServices.generateOtp({ data: payload });
			if (res?.statusCode === 200 || (res?.statusCode === 299)) {
				setState((prev) => ({
					...prev,
					nextStep: 1,
					userEmail: res?.data?.email,
					userId: res?.data?.userId,
					...(resend && { timeLeft: 60 }),
				}));
				if (res?.statusCode === 299) {
					notificationServices.generateNotification({
						type: 'warning',
						message: `OTP sent to ${maskEmail(res?.data?.email)}.Please use your official email ID next time`,
						config: { id: notificationId },
					});
				} else {
					notificationServices.generateNotification({
						type: 'success',
						message: `OTP sent successfully, Please check your email ${maskEmail(res?.data?.email)}`,
						config: {
							id: notificationId,
						},
					});
				}
				setLoading(false);
			}
		} catch (err) {
			notificationServices.generateNotification({
				type: 'error',
				message: err ? err : 'Unable to login, Please try again',
				config: {
					id: notificationId,
				},
			});
			setLoading(false);
		}
	}

	const formSubmitHandler = async () => {
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'Loading...',
		});
		setLoading(true);
		try {
			const req = {
				data: {
					UserName: username,
					...(toggleMode === 'otp' && { otp: otp.join('') }),
					...(toggleMode === 'password' && { Password: password }),
					forced: isforced,
				}
			};
			const res = await authServices.login(req);
			let message = '';
			let type = '';
			if (res.statusCode === 200) {
				setCookie('logged_in', 'true', 7 * 60 * 24);
				setCookie(
					'user',
					JSON.stringify({
						...res,
						color: getRandomNeonDarkColor(),
					}),
					7 * 60 * 24
				);
				setLastEmailModify(res?.userDetails?.emailLastModify);
				setUserConfig({
					...res,
					color: getRandomNeonDarkColor(),
				});
				const userName = get(res, 'userDetails.name', '');
				if (res.forced === true) {
					notificationServices.generateNotification({
						type: 'warning',
						message: "logged out of previous device",
					});
				}
				message = `Welcome ${userName}!`;
				type = 'wave';
				try {
					const data = await userRolesAndPermissions.getUserStores(req);
					localStorage.setItem('userStores', JSON.stringify(data.data));
					const userRoles = {};
					const userLevels = {};
					data?.data?.forEach((store) => {
						store?.levels?.forEach((roleAndLevel) => {
							userRoles[roleAndLevel.roleId] = true;
							userLevels[roleAndLevel.levelId] = true;
						});
					});
					dispatch(analyticsAction?.getShifts());
					setUserStores(data.data);
					useProductData(dispatch);
					dispatch(
						navigationActions.updateUserPermittedStores({
							userStores: data.data,
						})
					);
					if (Object.keys(userRoles).length > 0) {
						dispatch(
							navigationActions.handleUserRolesNavItem({
								userRoles,
							})
						);
						dispatch(
							navigationActions.updateUserPermissionsBasedOnLevels({
								userLevels: Object.keys(userLevels),
								internal: res.internal,
								accToInternal: true,
							})
						);
					}
					await signIn(res);
				} catch (err) {
					// eslint-disable-next-line no-console
					console.log('userStores', err);
				}
			} else if (res.statusCode === 199) {
				setIsForced(true);
				message = res.errorMessage;
				type = 'warning';
			} else if (res.statusCode === 401 && res.errorMessage === "Incorrect OTP") {
				setOtpError(true);
				deleteCookie('logged_in');
				deleteCookie('userCookie');
				message = res.errorMessage;
				type = 'error';
			} else if (res.statusCode === 402) {
				message = res?.error;
				type = 'error';
				setToggleMode('otp')
				setState((prev) => ({
					...prev,
					nextStep: 0,
				}));
			} else if (res.errorMessage !== undefined) {
				deleteCookie('logged_in');
				deleteCookie('userCookie');
				message = res.errorMessage;
				type = 'error';
			} else if (res.message !== undefined) {
				message = res.message;
				type = '';
			}
			notificationServices.generateNotification({
				type,
				message,
				config: {
					id: notificationId,
				},
			});
			setLoading(false);
		} catch (err) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Unable to login, Please try again',
				config: {
					id: notificationId,
				},
			});
			setLoading(false);
		}
	};

	if (isLoggedIn) {
		if (!lastEmailModify && isA2bCustomer) dispatch(modalActions.toggleEmailVerificationModal(true));
		const redirectionState = history?.location?.state?.from ?? null;
		const desiredUrlSplits = redirectionState?.pathname.split('/');
		let defaultRedirection = isMonginisCustomer ? `${urls.EXTENSION}${urls.PRODUCTION_ANALYSIS}` : !isBakingoCustomer ? `${urls.EXTENSION}${urls.PROCESS_FLOW_NEW}` : `${urls.EXTENSION}${urls.PROCESS_FLOW}`;
		let isDisabled = true;
		const desiredUrl = desiredUrlSplits?.slice(2)?.join('/');
		let allowedDesriredUrl = '';
		let parentUrl = '';
		if (!redirectionState || redirectionState?.pathname === '/' || redirectionState?.pathname === '/console2' || history?.location?.state === undefined) {
			return (
				<Redirect
					to={
						defaultRedirection
					}
				/>
			)
		}

		for (const urlSplit in desiredUrlSplits) {
			if (desiredUrlSplits[urlSplit] === urls.EXTENSION.substring(1)) {
				// eslint-disable-next-line no-continue
				continue;
			}
			allowedDesriredUrl += desiredUrlSplits[urlSplit];
			if (parentUrl !== '') {
				if (navState?.[parentUrl].submenu) {
					if (navState?.[parentUrl].submenu?.[allowedDesriredUrl]) {
						isDisabled = navState?.[parentUrl].submenu?.[allowedDesriredUrl]?.disabled;
					}
				}
			} else if (navState?.[allowedDesriredUrl]) {
				isDisabled = navState?.[allowedDesriredUrl]?.disabled;
				parentUrl = allowedDesriredUrl;
			}
			allowedDesriredUrl += '/';
		}
		if (isDisabled) {
			Object.keys(navState)?.forEach((key) => {
				if (!navState?.[key]?.submenu &&
					navState['/' + desiredUrl]) {
					isDisabled = navState['/' + desiredUrl]?.disabled;
				} else if (navState?.[key]?.submenu) {
					const navSub = navState?.[key]?.submenu;
					Object.keys(navSub)?.forEach((subKey) => {
						if (navSub?.[subKey]) {
							isDisabled = navSub[subKey].disabled;
						}
					});
				}
			});
		}
		if (!isDisabled && desiredUrl && desiredUrl !== 'login' && (desiredUrl !== 'process-flow' || desiredUrl !== 'operations-flow')) {
			if (navState?.['/' + desiredUrl] && !navState?.['/' + desiredUrl]?.submenu) {
				// eslint-disable-next-line prefer-template
				isDisabled = navState?.['/' + desiredUrl]?.disabled;
			}
			if (!isDisabled) {
				Object.keys(navState).forEach((key) => {
					if (!isDisabled && navState?.[key]?.submenu) {
						// eslint-disable-next-line prefer-template
						isDisabled = navState?.[key]?.submenu?.['/' + desiredUrl]?.disabled;
					} else if (!navState?.[key]?.submenu && navState?.[key]?.disabled === false && (defaultRedirection === `${urls.EXTENSION}${urls.PROCESS_FLOW}` || defaultRedirection === `${urls.EXTENSION}${urls.PROCESS_FLOW_NEW}`) &&
						navState?.[key]?.href
					) {
						defaultRedirection = navState?.[key]?.href;
					}
				});
			}
		}
		if (isDisabled) {
			Object.keys(navState)?.forEach((key) => {
				if (!navState?.[key]?.submenu && navState?.[key]?.disabled === false &&
					(defaultRedirection === (urls.EXTENSION + urls.PROCESS_FLOW) || defaultRedirection === (urls.EXTENSION + urls.PROCESS_FLOW_NEW)) &&
					navState?.[key]?.href) {
					defaultRedirection = navState?.[key]?.href;
				} else if (navState?.[key]?.submenu &&
					(defaultRedirection === (urls.EXTENSION + urls.PROCESS_FLOW) || defaultRedirection === (urls.EXTENSION + urls.PROCESS_FLOW_NEW))) {
					const navSub = navState?.[key]?.submenu;
					Object.keys(navSub)?.forEach((subKey) => {
						if (navSub?.[subKey]?.disabled === false &&
							(defaultRedirection === (urls.EXTENSION + urls.PROCESS_FLOW) || defaultRedirection === (urls.EXTENSION + urls.PROCESS_FLOW_NEW)) &&
							navSub[subKey].href) {
							defaultRedirection = navSub[subKey].href;
						}
					});
				}
			});
			return (
				<Redirect
					to={
						defaultRedirection
					}
				/>
			);
		}

		return (
			<Redirect
				to={
					redirectionState
						? `${redirectionState?.pathname}${redirectionState?.search}`
						: defaultRedirection
				}
			/>
		);
	}

	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			sendOtp();
		}
	};

	const handleInput = (e) => {
		const { fieldName, fieldValue } = inputHelper(e);
		if (otpError) setOtpError(false);
		setState({
			...state,
			[fieldName]: fieldValue,
		});
	};

	const formatTime = (seconds) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
	}

	const handleChange = (index, value) => {
		if (isNaN(value)) return;
		const newOtp = [...otp];
		newOtp[index] = value.slice(-1);
		setState((prev) => ({
			...prev,
			otp: newOtp,
		}));

		if (value && index < 3) {
			inputRefs[index + 1].current?.focus();
		}
	};

	const handleKeyPassword = (e) => {
		if (e.key === 'Enter') {
			formSubmitHandler();
		}
	}

	const handleKeyDown = (index, e) => {
		if (otpError) setOtpError(false);
		if (e.key === 'Backspace' && !otp[index] && index > 0) {
			inputRefs[index - 1].current?.focus();
		}
		if (e.key === 'Enter' && index === 3) {
			formSubmitHandler();
		}
	};

	const handlePaste = (e) => {
		e.preventDefault();
		const pastedData = e.clipboardData.getData('text').slice(0, 4).split('');
		const newOtp = [...otp];

		pastedData.forEach((char, i) => {
			if (i < 4 && !isNaN(char)) {
				newOtp[i] = char;
			}
		});
		setState((prev) => ({
			...prev,
			otp: newOtp,
		}));
		inputRefs[Math.min(pastedData.length, 3)].current?.focus();
	};

	const impactMetrics = [
		{
			value: (misSummary?.UniqueQRGenerated?.cumTillDate || misSummary?.TransactionalAppQRScans?.cumTillDate)
				? formatMetricValue((misSummary.UniqueQRGenerated.cumTillDate || 0) + (misSummary.TransactionalAppQRScans.cumTillDate || 0))
				: '32M+',
			label: 'Transactions',
			icon: TrendingUp
		},
		{
			value: misSummary?.FoodHandled?.cumTillDate
				? formatMetricValue(misSummary.FoodHandled.cumTillDate)
				: '16K+',
			label: 'Tons of Food',
			icon: Package
		},
		{
			value: misSummary?.UniqueSkus?.cumTillDate
				? formatMetricValue(misSummary.UniqueSkus.cumTillDate)
				: '10M+',
			label: 'SKUs',
			icon: Activity
		},
		{
			value: misSummary?.TransactionalAppQRScans?.cumTillDate
				? formatMetricValue(misSummary.TransactionalAppQRScans.cumTillDate)
				: '23M+',
			label: 'App QR Scans',
			icon: Phone
		},
		{
			value: (misSummary?.BaseKitchenActive?.currentQ || misSummary?.OutletActive?.currentQ)
				? formatMetricValue((misSummary.BaseKitchenActive.currentQ || 0) + (misSummary.OutletActive.currentQ || 0))
				: '146+',
			label: 'Digitally Transformed Kitchens',
			icon: Factory
		},
		{
			value: '1300+', // No direct match in misSummary, using default
			label: 'Food Workers Upskilled',
			icon: GraduationCap
		}
	];

	const credentials = [
		{
			title: 'Global Finalist',
			subtitle: '2025 World Food Forum',
			description: 'Startup Innovation Awards - Digital Innovation in Food Processing for data-driven innovations that enhance food quality, safety and sustainability',
			icon: Globe,
			color: 'from-blue-600 to-indigo-600'
		},
		{
			title: '2024 AI Disruptor',
			subtitle: 'by ETNOW',
			description: 'Recognition for transformative AI solutions in the food industry with #AIDisruptors2024',
			icon: Star,
			color: 'from-purple-600 to-violet-600'
		},
		{
			title: 'Intel GOLD Partner',
			subtitle: 'Certified Solution',
			description: 'UY Food 4.0 - Certified Intel GOLD Partner Solution for innovative IoT and AI implementations',
			icon: Shield,
			color: 'from-yellow-600 to-orange-600'
		},
		{
			title: '8 Patents',
			subtitle: '3 Granted',
			description: 'Intellectual property portfolio with 8 patents filed and 3 already granted for innovative food technology solutions',
			icon: FileText,
			color: 'from-green-600 to-emerald-600'
		}
	];

	// Auto-advance carousel every 6 seconds

	const nextSlide = () => {
		setCurrentSlide((prev) => (prev + 1) % slides.length);
	};

	const prevSlide = () => {
		setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
	};

	const currentSlideData = slides[currentSlide];

	// Image fallback component for achievement images
	const AchievementImage = ({ image, fallbackContent, alt }) => {
		if (image === 'new-award') {
			// For the problematic image, use a fallback content without the 9-star rating
			return (
				<div className="w-full flex items-center justify-center rounded-lg shadow-lg mx-auto bg-gradient-to-r from-purple-600 to-indigo-600 text-white" style={{ height: '250px' }}>
					<div className="text-center p-8">
						<Award className="w-16 h-16 mx-auto mb-4" />
						<h3 className="text-xl font-bold mb-2">ET NOW AI Disruptor 2024</h3>
						<p className="text-xs opacity-75 mt-2">Transformative AI Solutions in Food Industry</p>
					</div>
				</div>
			);
		}

		return (
			<ImageWithFallback
				src={image}
				alt={alt}
				className="w-full h-auto object-contain rounded-lg shadow-lg mx-auto"
				style={{ maxHeight: '300px', minHeight: '200px' }}
				fallback={
					<div className="w-full flex items-center justify-center rounded-lg shadow-lg mx-auto bg-gradient-to-r from-yellow-500 to-amber-500 text-white" style={{ height: '250px' }}>
						<div className="text-center p-8">
							<Award className="w-12 h-12 mx-auto mb-3" />
							<p className="text-lg font-semibold">{fallbackContent}</p>
						</div>
					</div>
				}
			/>
		);
	};

	// Global recognition image component
	const GlobalRecognitionImage = ({ imageData, alt }) => {
		return (
			<ImageWithFallback
				src={imageData.src}
				alt={alt}
				className="w-full h-auto object-contain rounded-lg shadow-lg mx-auto"
				style={{ maxHeight: '160px', minHeight: '100px' }}
				fallback={
					<div className="w-full flex items-center justify-center rounded-lg shadow-lg mx-auto bg-gradient-to-r from-blue-600 to-indigo-600 text-white" style={{ height: '130px' }}>
						<div className="text-center p-6">
							<Globe className="w-10 h-10 mx-auto mb-2" />
							<p className="text-sm font-semibold">{imageData.fallback}</p>
						</div>
					</div>
				}
			/>
		);
	};

	return (
		<div className="h-[100vh] w-full bg-gradient-to-br from-yellow-400 via-yellow-500 to-amber-600 flex">
			{/* Left Side - Carousel (60%) */}
			<div className="w-[60%] flex flex-col relative">
				{/* Carousel Container - 70% of middle area */}
				<div className='flex justify-between w-full item-center'>
					<img src={udyogYantraLogo} alt="UdyogYantra" className="h-[6rem] object-contain mx-auto" />
					<img src={resoee} alt="UdyogYantra" className="h-[6rem] object-contain mx-auto" />
				</div>
				<div className="flex-1 flex items-center justify-center px-6">
					<div className="w-full h-[70vh] relative">
						{/* Slide Content */}
						{currentSlideData.type === 'company' && (
							<div className="h-full flex flex-col justify-center items-center space-y-6 text-center bg-white/10 backdrop-blur-sm rounded-3xl border border-white/20">
								{/* Logo - 32px height */}
								<ImageWithFallback
									src={udyogYantraLogo}
									alt="UdyogYantra"
									className="h-[7rem] object-contain mx-auto"
									fallback={
										<div className="h-[3rem] flex items-center justify-center bg-yellow-600 text-white px-4 rounded">
											<span className="text-sm font-bold">UdyogYantra</span>
										</div>
									}
								/>

								{/* Updated Badge */}
								<Badge variant="secondary" className="bg-white/30 text-black border-black/10 hover:bg-white/40 backdrop-blur-sm text-lg px-6 py-2 h-[30px] rounded-[32px]">
									<span className="text-xl mr-3">🏭</span>
									UY Food AI : An Industry 4.0 Digital Food Platform
								</Badge>

								<div className="space-y-6 text-center">
									{/* Updated description */}
									<p className="text-xl text-black/90 max-w-3xl mx-auto leading-relaxed">
										Food 4.0 - Food Production &amp; Distribution Control System built for Food Factories, central kitchens &amp; commissaries fed Food Retail.
									</p>

									<div className="pt-4">
										<p className="text-lg text-black/80 italic max-w-2xl mx-auto">
											"Digitizing food operations from sourcing to distribution with complete traceability"
										</p>
									</div>
								</div>
							</div>
						)}

						{currentSlideData.type === 'impact' && (
							<div className="h-full flex flex-col justify-center p-6 space-y-6 bg-white/10 backdrop-blur-sm rounded-3xl border border-white/20">
								<div className="text-center mb-[1px]">
									<h2 className="text-4xl font-bold text-black mb-4">Our Impact</h2>
									<p className="text-lg text-black/90 max-w-3xl mx-auto leading-relaxed">
										Transforming the food industry with AI-powered solutions and measurable results across the entire supply chain ecosystem.
									</p>
								</div>

								{/* Layout for 6 metrics: 3 in first row, 3 in second row */}
								<div className="max-w-5xl mx-auto">
									{/* First row - 3 metrics */}
									<div className="grid grid-cols-3 gap-4 mb-4">
										{impactMetrics.slice(0, 3).map((metric, index) => (
											<div key={index} className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/30 transition-all duration-300 text-center">
												<div className="w-12 h-12 bg-gradient-to-r from-amber-600 to-orange-600 rounded-lg flex items-center justify-center mx-auto mb-3 shadow-lg">
													<metric.icon className="w-6 h-6 text-white" />
												</div>
												<div className="text-3xl font-bold text-black mb-2">{metric.value}</div>
												<div className="text-sm text-black/80">{metric.label}</div>
											</div>
										))}
									</div>
									{/* Second row - 3 metrics */}
									<div className="grid grid-cols-3 gap-4">
										{impactMetrics.slice(3, 6).map((metric, index) => (
											<div key={index} className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/30 transition-all duration-300 text-center">
												<div className="w-12 h-12 bg-gradient-to-r from-amber-600 to-orange-600 rounded-lg flex items-center justify-center mx-auto mb-3 shadow-lg">
													<metric.icon className="w-6 h-6 text-white" />
												</div>
												<div className="text-3xl font-bold text-black mb-2">{metric.value}</div>
												<div className="text-sm text-black/80">{metric.label}</div>
											</div>
										))}
									</div>
								</div>
							</div>
						)}
						{currentSlideData.type === 'credentials' && (
							<div className="h-full flex flex-col justify-center p-6 space-y-6 bg-white/10 backdrop-blur-sm rounded-3xl border border-white/20">
								<div className="text-center mb-[1px]">
									<h2 className="text-4xl font-bold text-black mb-4">Credentials & Certifications</h2>
									<p className="text-lg text-black/90 max-w-3xl mx-auto leading-relaxed">
										Validated excellence through industry partnerships, intellectual property, and prestigious recognitions
									</p>
								</div>

								<div className="grid grid-cols-1 lg:grid-cols-2 gap-4 max-w-4xl mx-auto">
									{credentials.map((cred, index) => (
										<div key={index} className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/30 transition-all duration-300">
											<div className="flex items-start space-x-3">
												<div className={`w-12 h-12 bg-gradient-to-r ${cred.color} rounded-lg flex items-center justify-center shadow-lg flex-shrink-0`}>
													<cred.icon className="w-6 h-6 text-white" />
												</div>
												<div className="flex-1">
													<h3 className="text-lg font-bold text-black mb-1">{cred.title}</h3>
													<p className="text-sm text-black/80 mb-2">{cred.subtitle}</p>
													<p className="text-xs text-black/70 leading-relaxed">{cred.description}</p>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						)}
						{currentSlideData.type === 'achievement' && (
							<div className="h-full flex flex-col justify-center p-6 space-y-6 bg-white/10 backdrop-blur-sm rounded-3xl border border-white/20">
								<div className="text-center mb-[1px]">
									<h2 className="text-4xl font-bold text-black mb-4">{currentSlideData.title}</h2>
									<p className="text-lg text-black/90 max-w-3xl mx-auto leading-relaxed">
										Recognized globally for innovation in food technology and operations management
									</p>
								</div>
								{/* Single achievement image centered */}
								<div className="max-w-2xl mx-auto">
									<div className="bg-white/20 backdrop-blur-sm rounded-xl p-8 border border-white/20 hover:bg-white/30 transition-all duration-300 text-center">
										<AchievementImage
											image={currentSlideData.image}
											fallbackContent={currentSlideData.fallbackContent}
											alt="Achievement"
										/>
									</div>
								</div>
							</div>
						)}

						{currentSlideData.type === 'group' && (
							<div className="h-full flex flex-col justify-center p-6 space-y-6 bg-white/10 backdrop-blur-sm rounded-3xl border border-white/20">
								<div className="text-center mb-[1px]">
									<h2 className="text-4xl font-bold text-black mb-4">{currentSlideData.title}</h2>
									<p className="text-lg text-black/90 max-w-3xl mx-auto leading-relaxed">
										Manage Sourcing, Production, Distribution viaOne-for-all System
									</p>
								</div>
								{/* Single achievement image centered */}
								<div className="max-w-2xl mx-auto">
									<div className="bg-white/20 backdrop-blur-sm rounded-xl p-8 border border-white/20 hover:bg-white/30 transition-all duration-300 text-center">
										<AchievementImage
											image={currentSlideData.image}
											fallbackContent={currentSlideData.fallbackContent}
											alt="Group"
										/>
									</div>
								</div>
							</div>
						)}
						{currentSlideData.type === 'global-recognition' && (
							<div className="h-full flex flex-col justify-center p-6 space-y-6 bg-white/10 backdrop-blur-sm rounded-3xl border border-white/20">
								<div className="text-center mb-[1px]">
									<h2 className="text-4xl font-bold text-black mb-4">{currentSlideData.title}</h2>
									<p className="text-lg text-black/90 max-w-3xl mx-auto leading-relaxed">
										Acknowledged by global organizations including FAO and the United Nations for our innovative contributions to the food industry
									</p>
								</div>
								{/* Single achievement image centered */}
								<div className="max-w-2xl mx-auto">
									<div className="bg-white/20 backdrop-blur-sm rounded-xl p-8 border border-white/20 hover:bg-white/30 transition-all duration-300 text-center">
										<AchievementImage
											image={currentSlideData.image}
											fallbackContent={currentSlideData.fallbackContent}
											alt="Global Recognition"
										/>
									</div>
								</div>
							</div>
						)}
					</div>
					{/* Navigation Controls */}
					<div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex items-center space-x-4">
						<Button
							onClick={prevSlide}
							variant="outline"
							size="icon"
							className="bg-white/20 backdrop-blur-sm border-white/20 hover:bg-white/30 text-black"
						>
							<ChevronLeft className="w-5 h-5" />
						</Button>

						<div className="flex space-x-2">
							{slides.map((_, index) => (
								<button
									key={index}
									onClick={() => setCurrentSlide(index)}
									className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentSlide
										? 'bg-black/80 w-8'
										: 'bg-black/30 hover:bg-black/50'
										}`}
								/>
							))}
						</div>

						<Button
							onClick={nextSlide}
							variant="outline"
							size="icon"
							className="bg-white/20 backdrop-blur-sm border-white/20 hover:bg-white/30 text-black"
						>
							<ChevronRight className="w-5 h-5" />
						</Button>
					</div>
				</div>
			</div>

			{/* Right Side - Login (40%) */}
			<div className="w-[40%] bg-gradient-to-br from-yellow-100 to-gray-100 flex items-center justify-center p-8">
				<div className="w-full max-w-md">
					<Card className="shadow-2xl border-0 bg-white py-8 px-0">
						<CardHeader className="space-y-4">
							{/* UY Logo above Console Access */}
							<div className="mb-2">
								{(appConfig?.logob64 || appConfig?.logo) ? (
									<ImageWithFallback
										src={appConfig?.logob64 ?? appConfig?.logo}
										alt={appConfig?.companyName}
										className="h-8 object-contain mx-auto"
										fallback={
											<div className="h-8 flex items-center justify-center bg-yellow-600 text-white px-4 rounded mx-auto">
												<span className="text-sm font-bold">{appConfig?.companyName}</span>
											</div>
										}
									/>
								) : (
									<Skeleton variant='rounded' className='mx-auto' width={200} height={75} />
								)}
							</div>
							{/* Removed the UY icon element */}
							<div className="text-center !mt-0">
								<CardTitle className="text-2xl text-gray-900 mb-2">Console Login</CardTitle>
								<CardDescription className="text-gray-600">
									Login to your {appConfig?.companyName} account
								</CardDescription>
							</div>
						</CardHeader>
						{nextStep === 0 && (
							<CardContent className="space-y-6">
								<div className="space-y-2">
									{toggleMode === 'password' && (isA2bCustomer || isBakingoCustomer) && <p className='text-[13.5px] rounded-md text-center p-2 bg-orange-100 border border-orange-200 text-orange-400 '>Password login ends on 15 Dec 2025. Use secure email login instead</p>}
									<Tabs
										value={toggleMode}
										onValueChange={(value) => setToggleMode(value)}
										defaultValue={toggleMode}
									>
										<TabsList className={`inline-flex h-11 items-center justify-center rounded-lg bg-gray-100 p-1 text-gray-600 w-full ${toggleMode === 'otp' ? 'mb-6' : ''}`}>
											{tabList.map((ele) => {
												return (
													<TabsTrigger
														key={ele.value}
														value={ele.value}
														className="flex-1 inline-flex items-center justify-center whitespace-nowrap rounded-md px-6 py-2 text-sm font-semibold ring-offset-white transition-all data-[state=active]:bg-yellow-400 data-[state=active]:text-gray-900 data-[state=active]:shadow-sm data-[state=inactive]:text-gray-600 hover:text-gray-900"
													>
														<div className="flex items-center gap-2">
															{ele.icon}
															{ele.label}
														</div>
													</TabsTrigger>
												);
											})}
										</TabsList>
									</Tabs>
									<label htmlFor="username" className="text-sm font-medium text-gray-700">
										{toggleMode === 'otp' ? 'Username/Email' : 'Username'}
									</label>
									<div className="relative">
										<User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
										<Input
											ref={usernameRef}
											id="username"
											type="text"
											name='username'
											onChange={handleInput}
											placeholder={toggleMode === 'otp' ? 'Enter your username/email' : 'Enter your username'}
											value={username}
											className="h-12 pl-10 border-gray-200 focus:border-yellow-500 focus:ring-yellow-500"
											disabled={loading}
											{...(toggleMode === 'otp' ? { onKeyDown: handleKeyPress } : {})}
										/>
									</div>
								</div>
								{/* password mode */}
								{toggleMode === 'password' && (
									<>
										<div className="space-y-2">
											<label htmlFor="password" className="text-sm font-medium text-gray-700">
												Password
											</label>
											<div className="relative">
												<Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
												<Input
													id="password"
													name='password'
													type={showPassword ? "text" : "password"}
													placeholder="Enter your password"
													value={password}
													onChange={handleInput}
													className="h-12 pl-10 pr-12 border-gray-200 focus:border-yellow-500 focus:ring-yellow-500"
													disabled={loading}
													onKeyPress={handleKeyPassword} />
												<button
													type="button"
													onClick={() => setShowPassword(!showPassword)}
													className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
												>
													{showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
												</button>
											</div>
										</div>
										<Button
											onClick={formSubmitHandler}
											disabled={!username || !password || loading}
											className="w-full h-12 bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600 text-white font-medium"
										>
											{loading ? (
												<div className="flex items-center space-x-2">
													<div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
													<span>Signing In...</span>
												</div>
											) : (
												<>
													Sign In
													<ArrowRight className="w-4 h-4 ml-2" />
												</>
											)}
										</Button>
									</>
								)}
								{/* otp mode */}
								{toggleMode === 'otp' && (
									<Button
										onClick={sendOtp}
										disabled={!username || loading}
										className="w-full h-12 bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600 text-white font-medium"
									>
										{loading ? (
											<div className="flex items-center space-x-2">
												<div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
												<span>Sending OTP...</span>
											</div>
										) : (
											<>
												Send OTP
												<ArrowRight className="w-4 h-4 ml-2" />
											</>
										)}
									</Button>
								)}
							</CardContent>
						)}
						{nextStep === 1 && (
							<CardContent className="space-y-6">
								<div className="space-y-6">
									<div className="space-y-2">
										<p className="text-[22px] flex justify-center font-semibold">Enter OTP</p>
										<div className="space-y-4">
											<p className="flex justify-center text-gray-600 text-sm">
												We have sent an OTP to <span className="font-medium text-gray-900 ml-1">{maskEmail(userEmail)}</span>
											</p>
											<div className="flex justify-center gap-3 py-4">
												{otp.map((digit, index) => (
													<input
														key={index}
														ref={inputRefs[index]}
														type="text"
														inputMode="numeric"
														maxLength={1}
														value={digit}
														onChange={(e) => handleChange(index, e.target.value)}
														onKeyDown={(e) => handleKeyDown(index, e)}
														onPaste={handlePaste}
														className={`w-14 h-14 text-center text-2xl font-semibold border-2 rounded-lg focus:outline-none transition-colors
															${otpError ? 'border-red-500 focus:border-red-500' : 'border-gray-300 focus:border-yellow-500'}`}
													/>
												))}
											</div>
											<div className="flex items-center justify-center gap-[7rem] text-sm">
												<p className="font-semibold text-gray-900">{formatTime(timeLeft)}</p>
												<button
													onClick={() => {
														sendOtp(true);
														setOtpError(false);
														setState((prev) => ({
															...prev,
															timeLeft: 0,
														}));
													}}
													disabled={timeLeft > 0}
													className={`${timeLeft > 0 ? 'text-gray-400' : 'text-yellow-600 hover:text-yellow-700 cursor-pointer transition-colors'}`}
												>
													Resend OTP
												</button>
											</div>
											<div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6 w-full">
												<button
													onClick={() =>
														setState((prev) => ({
															...prev,
															nextStep: 0,
															otp: ['', '', '', ''],
															timeLeft: 60,
														}))
													}
													className="flex-1 bg-slate-300 hover:bg-slate-400 text-white font-medium py-3 rounded-lg transition-colors w-full sm:w-auto"
												>
													Back
												</button>

												<button
													onClick={formSubmitHandler}
													disabled={otp.some((digit) => !digit)}
													className="flex-1 bg-yellow-500 hover:bg-yellow-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-medium py-3 rounded-lg transition-colors w-full sm:w-auto"
												>
													Verify OTP
												</button>
											</div>

										</div>
									</div>
								</div>
							</CardContent>
						)}
					</Card>

					{/* Updated Support Contact */}
					<div className="mt-8 text-center">
						<p className="text-sm text-gray-700 mb-4">Need help? Contact our support team</p>
						<div className="flex justify-center space-x-6 text-sm text-gray-600">
							<div className="flex items-center space-x-1">
								<Mail className="w-4 h-4" />
								<span>support@udyoyantra.com</span>
							</div>
							<div className="flex items-center space-x-1">
								<Phone className="w-4 h-4" />
								<span>9958863566</span>
							</div>
						</div>

						{/* Website Link */}
						<div className="mt-6 pt-4 border-t border-gray-200">
							<a
								href="https://www.udyogyantra.ai"
								target="_blank"
								rel="noopener noreferrer"
								className="inline-flex items-center text-sm text-yellow-600 hover:text-yellow-700 transition-colors duration-200"
							>
								<span>www.udyogyantra.ai</span>
								<ExternalLink className="w-3 h-3 ml-1" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { navState } = state.navigation;
	return {
		navState,
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
